








import { Component, Mixins, Prop } from "vue-property-decorator";
import { StandardOption } from "../../../system/selectors/mixins";

@Component({
  components: {
  }
})
export default class InputMethodSelector extends Mixins() {
  @Prop()
  displayTexts: { key: any, text: string }[];
  @Prop()
  optionSet: any[];
  /**
   * 未選択時の値を設定する
   * null, undefined以外が設定されているとチェックを外せるラジオボタンのように動作する
   */
  @Prop()
  unselection: any;

  get options(): StandardOption<any>[] {
    return this.optionSet.map(x => this.toOption(x, this.displayTexts.find(y => y.key === x).text));
  }

  get displayOptions(): StandardOption<any>[] {
    return this.options.filter(x => x.value !== this.unselection);
  }

  private toOption(kind: any, text: string): StandardOption<number> {
    return new StandardOption<any>(text, kind, "入力方法を" + text + "に切り替えます");
  }
}
